import script from "./AddRxNoteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddRxNoteModal.vue?vue&type=script&setup=true&lang=js"

import "./AddRxNoteModal.vue?vue&type=style&index=0&id=72f5fa36&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72f5fa36"]])

export default __exports__